module.exports = __webpack_public_path__ + "static/img/main@2x.79f971e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/install/main@2x.gif
// module id = Dqbe
// module chunks = 1